<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'pro-report-atendimento') {
            next({ name: 'promotor-atendimento-list', replace: true });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'pro-report-atendimento') {
            this.$router.push({ name: 'promotor-atendimento-list' });
        }
    },
};
</script>
